import type { EmployeePick, ParticipantInput } from './types'

/**
 * Seçicideki kişiyi istek gövdesindeki kişi girdisine çevirir — katılımcı ve dağıtım listesi (119)
 * ortak; tutanak oluşturma ve düzenleme aynı eşlemeyi kullanır.
 *
 * <p>Liste etiketi (`managerListId`, 115) gövdeye konur: taşınmazsa kişi kaydedilir ama hangi listeden
 * geldiği kaybolurdu — ekranda kişi görünür, bağ sessizce kopardı.
 */
export function toPersonInput(p: EmployeePick): ParticipantInput {
  return {
    employeeId: p.employeeId,
    firstName: p.firstName,
    lastName: p.lastName,
    businessMail: p.businessMail,
    jobTitleTr: p.jobTitleTr,
    jobTitleEn: p.jobTitleEn,
    managerListId: p.managerListId ?? null,
  }
}
